module.exports = __webpack_public_path__ + "img/Biometrics.c37d6b2d.jpeg";